export default () => {
  return document.querySelector("[name='csrf-token']").content
}
